export default {
      id: "media_tab_map-usage",
      viewBox: "0 0 25 20",
      url: "/" + "sprite.svg#media_tab_map",
      toString: function () {
        return this.url;
      }
    }